import { ITextBox } from '@tencent/alloy-editor';

/**
 * textBox相对整个文本layout的坐标
 * @param textBox
 */
export function getOffsetOfTextBox(textBox: ITextBox): { x: number, y: number } {
    const offset = { x: textBox.rect.x, y: textBox.rect.y };
    let currentBox: any = textBox.parentBox;
    while (currentBox) {
        offset.x += currentBox.rect.x;
        offset.y += currentBox.rect.y;
        currentBox = currentBox.parentBox;
    }
    return offset;
}

/**
 * 字符串是否可见
 * @param str
 */
export function isStringVisible(str: string): boolean {
    // 使用正则表达式匹配任何空白字符（包括空格、制表符和换行符）
    const nonVisibleChars = /^\s*$/;
    return !nonVisibleChars.test(str);
}
